import { render, staticRenderFns } from "./mainLeft.vue?vue&type=template&id=440f8822&"
import script from "./mainLeft.vue?vue&type=script&lang=js&"
export * from "./mainLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports